import { SHAPES } from './constants'

const layouts = {
    invader_1: {
        fg: [
            {
                shape: SHAPES.TRIANGLE,
                rotate: 0,
                scale: 140,
                attempts: 3,
                pallet: 2,
            },
            {
                shape: SHAPES.LIGHTNING,
                rotate: 0,
                scale: 50,
                attempts: 300,
                pallet: 1,
            },
            {
                shape: SHAPES.LITTLE_SQUARE,
                rotate: 0,
                scale: 60,
                attempts: 200,
                pallet: 0,
            },
            {
                shape: SHAPES.LITTLE_SQUARE,
                rotate: 0,
                scale: 40,
                attempts: 800,
                pallet: 0,
            },
            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 20,
                attempts: 1300,
                pallet: 0,
            },
        ],
        bg: [
            {
                shape: SHAPES.TRIANGLE,
                rotate: 0,
                scale: 600,
                attempts: 30,
                pallet: 1,
            },
            {
                shape: SHAPES.TRIANGLE,
                rotate: 0,
                scale: 100,
                attempts: 30,
                pallet: 1,
            },
            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 40,
                attempts: 1300,
                pallet: 1,
            },
            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 20,
                attempts: 1300,
                pallet: 0,
            },
        ]
    },
    invader_2: {
        fg: [
            {
                shape: SHAPES.EXCLAMATION,
                rotate: 5,
                scale: 70,
                attempts: 3,
                pallet: 0,
            },
            {
                shape: SHAPES.EXCLAMATION,
                rotate: 5,
                scale: 50,
                attempts: 300,
                pallet: 1,
            },
            {
                shape: SHAPES.EXCLAMATION,
                rotate: 0,
                scale: 60,
                attempts: 200,
                pallet: 0,
            },
            {
                shape: SHAPES.EXCLAMATION,
                rotate: -5,
                scale: 20,
                attempts: 1500,
                pallet: 1,
            }
        ],
        bg: [
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 1000,
                attempts: 130,
                pallet: 1,
            },
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 100,
                attempts: 40,
                pallet: 1,
            },
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 40,
                attempts: 140,
                pallet: 0,
            },
            {
                shape: SHAPES.LINE,
                rotate: 90,
                scale: 90,
                attempts: 40,
                pallet: 0,
            },
            {
                shape: SHAPES.LINE,
                rotate: 90,
                scale: 70,
                attempts: 400,
                pallet: 0,
            },
            {
                shape: SHAPES.LINE,
                rotate: 90,
                scale: 40,
                attempts: 1000,
                pallet: 0,
            }
        ]
    },
    invader_3: {
        fg: [
            {   
                shape: SHAPES.LITTLE_SQUARE,
                rotate: 0,
                scale: 400,
                attempts: 100,
                pallet: 1,
            },
            {   
                shape: SHAPES.LIGHTNING,
                rotate: 0,
                scale: 100,
                attempts: 300,
                pallet: 0,
            },
            {
                shape: SHAPES.PLUS,
                rotate: 45,
                scale: 30,
                attempts: 200,
                pallet: 1,
            },
            {
                shape: SHAPES.LINE,
                rotate: 90,
                scale: 20,
                attempts: 1200,
                pallet: 0,
            },
        ],
        bg: [
            {
                shape: SHAPES.LITTLE_SQUARE,
                rotate: 0,
                scale: 1000,
                attempts: 100,
                pallet: 0,
            },
            {
                shape: SHAPES.TRIANGLE,
                rotate: 0,
                scale: 30,
                attempts: 1000,
                pallet: 1,
            },

        ]
    },
    invader_4: {
        fg: [
            {
                shape: SHAPES.PLUS,
                rotate: 0,
                scale: 500,
                attempts: 10,
                pallet: 2,
            },
            {
                shape: SHAPES.TRIANGLE,
                rotate: 0,
                scale: 50,
                attempts: 300,
                pallet: 1,
            },
            {
                shape: SHAPES.LITTLE_SQUARE,
                rotate: 0,
                scale: 30,
                attempts: 500,
                pallet: 0,
            },
            {
                shape: SHAPES.LITTLE_SQUARE,
                rotate: 0,
                scale: 10,
                attempts: 500,
                pallet: 0,
            }
        ],
        bg: [
            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 90,
                attempts: 100,
                pallet: 0,
            },
            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 50,
                attempts: 500,
                pallet: 0,
            },
            {
                shape: SHAPES.LIGHTNING,
                rotate: 0,
                scale: 30,
                attempts: 500,
                pallet: 0,
            },
            {
                shape: SHAPES.LITTLE_SQUARE,
                rotate: 0,
                scale: 10,
                attempts: 500,
                pallet: 2,
            }
        ]
    },
    
    skull_1: {
        fg: [
            {
                shape: SHAPES.LIGHTNING,
                rotate: 0,
                scale: 600,
                attempts: 3,
                pallet: 2,
            },   
            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 100,
                attempts: 200,
                pallet: 1,
            }, 
            {
                shape: SHAPES.LITTLE_SQUARE,
                rotate: 0,
                scale: 70,
                attempts: 400,
                pallet: 0,
            },
           {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 50,
                attempts: 400,
                pallet: 0,
            },
            {
                shape: SHAPES.LITTLE_SQUARE,
                rotate: 0,
                scale: 30,
                attempts: 1400,
                pallet: 1,
            },
        ],
        bg: [
            {
                shape: SHAPES.PLUS,
                rotate: 0,
                scale: 100,
                attempts: 400,
                pallet: 1,
            },
            {
                shape: SHAPES.LIGHTNING,
                rotate: 0,
                scale: 50,
                attempts: 100,
                pallet: 0,
            },
            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 50,
                attempts: 1000,
                pallet: 0,
            }
        ],
    },
    skull_2: {
        fg: [
            {
                shape: SHAPES.ARROW,
                rotate: 0,
                scale: 1000,
                attempts: 3,
                pallet: 2,
            },   
            {
                shape: SHAPES.EXCLAMATION,
                rotate: 0,
                scale: 40,
                attempts: 300,
                pallet: 0,
            },   
            {
                shape: SHAPES.EXCLAMATION,
                rotate: 0,
                scale: 40,
                attempts: 600,
                pallet: 1,
            }, 
            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 10,
                attempts: 600,
                pallet: 0,
            },
            {
                shape: SHAPES.LITTLE_SQUARE,
                rotate: 0,
                scale: 20,
                attempts: 600,
                pallet: 1,
            }, 
        ],
        bg: [
            {
                shape: SHAPES.ARROW,
                rotate: 0,
                scale: 300,
                attempts: 30,
                pallet: 0,
            },
            {
                shape: SHAPES.ARROW,
                rotate: 0,
                scale: 150,
                attempts: 10,
                pallet: 1,
            },
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 100,
                attempts: 30,
                pallet: 1,
            },
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 60,
                attempts: 50,
                pallet: 0,
            },    
            {
                shape: SHAPES.LITTLE_SQUARE,
                rotate: 0,
                scale: 20,
                attempts: 200,
                pallet: 2,
            },    
            /*{
                shape: SHAPES.PLUS,
                rotate: 0,
                scale: 100,
                attempts: 400,
                pallet: 1,
            },
            {
                shape: SHAPES.LIGHTNING,
                rotate: 0,
                scale: 50,
                attempts: 100,
                pallet: 0,
            },
            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 50,
                attempts: 1000,
                pallet: 0,
            }*/
        ],
    },
    skull_3: {
        fg: [
            {
                shape: SHAPES.PLUS,
                rotate: 0,
                scale: 200,
                attempts: 3,
                pallet: 2,
            },
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 100,
                attempts: 30,
                pallet: 1,
           },
           {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 50,
                attempts: 300,
                pallet: 0,
           },
           {
                shape: SHAPES.LINE,
                rotate: 90,
                scale: 50,
                attempts: 300,
                pallet: 0,
           },
           {
                shape: SHAPES.LINE,
                rotate: 90,
                scale: 30,
                attempts: 1300,
                pallet: 1,
           }
        ],
        bg: [
            {
                shape: SHAPES.PLUS,
                rotate: 0,
                scale: 60,
                attempts: 10,
                pallet: 0,
            },
            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 70,
                attempts: 100,
                pallet: 1,
            },
              {
                shape: SHAPES.LIGHTNING,
                rotate: 0,
                scale: 30,
                attempts: 100,
                pallet: 0,
            },
            {
                shape: SHAPES.LINE,
                rotate: 180,
                scale: 50,
                attempts: 300,
                pallet: 0,
            },
            {
                shape: SHAPES.LINE,
                rotate: 180,
                scale: 20,
                attempts: 3000,
                pallet: 1,
            },
        ],
    },
    skull_4: {
        fg: [
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 200,
                attempts: 3,
                pallet: 2,
            },
            {
                shape: SHAPES.LITTLE_SQUARE,
                rotate: 0,
                scale: 100,
                attempts: 30,
                pallet: 1,
           },
           {
                shape: SHAPES.PLUS,
                rotate: 0,
                scale: 50,
                attempts: 300,
                pallet: 0,
           },
           {
                shape: SHAPES.EXCLAMATION,
                rotate: 180,
                scale: 50,
                attempts: 300,
                pallet: 0,
           },
           {
                shape: SHAPES.LINE,
                rotate: 180,
                scale: 30,
                attempts: 1300,
                pallet: 1,
           }
        ],
        bg: [
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 200,
                attempts: 10,
                pallet: 0,
            },
            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 70,
                attempts: 100,
                pallet: 1,
            },
              {
                shape: SHAPES.LIGHTNING,
                rotate: 5,
                scale: 30,
                attempts: 50,
                pallet: 0,
            },
            {
                shape: SHAPES.LIGHTNING,
                rotate: 5,
                scale: 50,
                attempts: 100,
                pallet: 0,
            },
            {
                shape: SHAPES.LIGHTNING,
                rotate: 5,
                scale: 20,
                attempts: 500,
                pallet: 1,
            },
            {
                shape: SHAPES.LITTLE_SQUARE,
                rotate: 0,
                scale: 20,
                attempts: 300,
                pallet: 2,
            },
        ],
    },

    // non-shape layouts
    full_1: {
        fg: [
            {
                shape: SHAPES.LIGHTNING,
                rotate: 0,
                scale: 1500,
                attempts: 30,
                pallet: 2,
            },
            {
                shape: SHAPES.LITTLE_SQUARE,
                rotate: 0,
                scale: 600,
                attempts: 30,
                pallet: 1,
            },
            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 300,
                attempts: 300,
                pallet: 0,
            },
            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 80,
                attempts: 1000,
                pallet: 0,
            },
            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 30,
                attempts: 1000,
                pallet: 1,
            },
        ],
        bg: [
            {
                shape: SHAPES.LIGHTNING,
                rotate: 0,
                scale: 170,
                attempts: 50,
                pallet: 0,
            },
            {
                shape: SHAPES.LIGHTNING,
                rotate: 0,
                scale: 70,
                attempts: 300,
                pallet: 0,
            },
            {
                shape: SHAPES.PLUS,
                rotate: 0,
                scale: 75,
                attempts: 1500,
                pallet: 1,
            },
            {
                shape: SHAPES.PLUS,
                rotate: 0,
                scale: 25,
                attempts: 1500,
                pallet: 1,
            },
        ]
    },
    full_2: {
        fg: [
            {
                shape: SHAPES.PLUS,
                rotate: 0,
                scale: 1500,
                attempts: 30,
                pallet: 1,
            },
            {
                shape: SHAPES.ARROW,
                rotate: 0,
                scale: 70,
                attempts: 300,
                pallet: 1,
            },            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 60,
                attempts: 300,
                pallet: 0,
            },
            {
                shape: SHAPES.ARROW,
                rotate: 0,
                scale: 30,
                attempts: 1300,
                pallet: 0,
            }, 
        ],
        bg: [
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 400,
                attempts: 30,
                pallet: 0,
            },
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 100,
                attempts: 400,
                pallet: 0,
            }
        ]
    },
    full_3: {
        fg: [
            {
                shape: SHAPES.LIGHTNING,
                rotate: 0,
                scale: 1500,
                attempts: 30,
                pallet: 2,
            },
            {
                shape: SHAPES.LITTLE_SQUARE,
                rotate: 0,
                scale: 600,
                attempts: 30,
                pallet: 1,
            },
            {
                shape: SHAPES.LINE,
                rotate: 0,
                scale: 300,
                attempts: 300,
                pallet: 0,
            },
        ],
        bg: [
            {
                shape: SHAPES.LIGHTNING,
                rotate: 0,
                scale: 170,
                attempts: 50,
                pallet: 0,
            },
            {
                shape: SHAPES.LIGHTNING,
                rotate: 0,
                scale: 70,
                attempts: 300,
                pallet: 0,
            },
            {
                shape: SHAPES.PLUS,
                rotate: 0,
                scale: 75,
                attempts: 1500,
                pallet: 1,
            },
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 40,
                attempts: 500,
                pallet: 0,
            },
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 25,
                attempts: 500,
                pallet: 1,
            },
        ]
    },
    full_4: {
        fg: [
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 1500,
                attempts: 40,
                pallet: 1,
            },
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 500,
                attempts: 300,
                pallet: 0,
            },
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 140,
                attempts: 140,
                pallet: 1,
            }
        ],
        bg: [
            {
                shape: SHAPES.ARROW,
                rotate: 0,
                scale: 140,
                attempts: 400,
                pallet: 1,
            },
            {
                shape: SHAPES.HOLLOW_SQUARE,
                rotate: 0,
                scale: 40,
                attempts: 700,
                pallet: 1,
            },
            {
                shape: SHAPES.ARROW,
                rotate: 0,
                scale: 40,
                attempts: 700,
                pallet: 0,
            }
        ]
    },
    full_5: {
        fg: [
            {
                shape: SHAPES.TRIANGLE,
                scale: 1500,
                attempts: 150,
                pallet: 2,
            },
            {
                shape: SHAPES.LINE,
                scale: 50,
                attempts: 1000,
                pallet: 1,
            },
            {
                shape: SHAPES.EXCLAMATION,
                scale: 20,
                attempts: 1500,
                pallet: 0,
            }
        ],
        bg: [
            {
                shape: SHAPES.TRIANGLE,
                scale: 800,
                attempts: 150,
                pallet: 2,
            },
            {
                shape: SHAPES.TRIANGLE,
                scale: 400,
                attempts: 450,
                pallet: 2,
            },
            {
                shape: SHAPES.HOLLOW_SQUARE,
                scale: 100,
                attempts: 150,
                pallet: 0,
            },
            {
                shape: SHAPES.HOLLOW_SQUARE,
                scale: 50,
                attempts: 150,
                pallet: 0,
            },
            {
                shape: SHAPES.PLUS,
                scale: 30,
                attempts: 1500,
                pallet: 1,
            }
        ]
    }
}

export default layouts
